import {MuiIcons} from "@leap4/frontend";
import React from "react";

const { ArrowDownward, ArrowUpward } = MuiIcons;


export const ComparedValuePercentChange = (props: { percentChange: number }) => {
    const {percentChange} = props
    const color = +percentChange < 0 ? 'red' : 'green';
    const metricSignByChange = +percentChange<0? <ArrowDownward style={{fontSize:"8px"}}/>:<ArrowUpward style={{fontSize:"12px"}}/>;

    const percentChangeFormatted = new Intl.NumberFormat('en', {
        style: 'percent',
        maximumFractionDigits:2

    }).format(percentChange/100)


    return (<b style={{color, fontSize: '9.5px'}}>{metricSignByChange}({percentChangeFormatted})</b>)

}